import React from 'react';
import styled from '@emotion/styled';
import { ExportOutlined } from '@ant-design/icons';

// The link text already names the link, so the icon stays out of the accessibility tree.
const ExternalLinkIcon = () => <SpacedExportOutlined aria-hidden />;

const SpacedExportOutlined = styled(ExportOutlined)`
  margin-inline-start: 0.25rem;
  font-size: 1em;
`;

export default ExternalLinkIcon;
